import { render, staticRenderFns } from "./OrderControl.vue?vue&type=template&id=28414a7a&scoped=true"
import script from "./OrderControl.vue?vue&type=script&lang=js"
export * from "./OrderControl.vue?vue&type=script&lang=js"
import style0 from "./OrderControl.vue?vue&type=style&index=0&id=28414a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28414a7a",
  null
  
)

export default component.exports